// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Reyy","header":"ClearentDisclaimer_header__2fORs","inner":"ClearentDisclaimer_inner__1i5TA"};